import { IUserInfo } from '../Users/users.types'

const getUserAlias = (userInfo: IUserInfo) => {
  if (!userInfo || (userInfo.firstName.length === 0 && userInfo.lastName.length === 0)) {
    return 'NA'
  }

  if (userInfo.firstName.length === 0 || userInfo.lastName.length === 0) {
    return userInfo.firstName.length === 0 ? userInfo.lastName[0].toUpperCase() : userInfo.firstName[0].toUpperCase()
  } else {
    return (userInfo.firstName[0] + userInfo.lastName[0]).toUpperCase()
  }
}

const getFullName = (userInfo: Pick<IUserInfo, 'lastName' | 'middleName' | 'firstName'>) => {
  if (!userInfo) return '-'

  return [userInfo.lastName, userInfo.firstName, userInfo?.middleName].filter(Boolean).join(' ')
}

const getShortName = (userInfo: IUserInfo) => {
  if (!userInfo || (!userInfo.firstName && !userInfo.lastName)) return ''
  if (userInfo.firstName && !userInfo.lastName) return userInfo.firstName
  if (!userInfo.firstName && userInfo.lastName) return userInfo.lastName
  return `${userInfo.firstName} ${userInfo.lastName[0]}.`
}

const userUtils = { getUserAlias, getFullName, getShortName }

export default userUtils
